import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
 * Heading element configurable with size and adaptivity
 */
export var BaseHeading = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseHeading, _React$Component);
  var _super = _createSuper(BaseHeading);
  function BaseHeading() {
    _classCallCheck(this, BaseHeading);
    return _super.apply(this, arguments);
  }
  _createClass(BaseHeading, [{
    key: "render",
    value: function render() {
      var _cx;
      var _this$props = this.props,
        children = _this$props.children,
        level = _this$props.level,
        isAdaptive = _this$props.isAdaptive,
        isStyled = _this$props.isStyled,
        tagName = _this$props.tagName,
        className = _this$props.className;
      var Tag = tagName || "h".concat(level);
      return /*#__PURE__*/React.createElement(Tag, {
        className: cx('component', (_cx = {}, _defineProperty(_cx, "h".concat([level]), level), _defineProperty(_cx, "adaptive", isAdaptive), _defineProperty(_cx, "styled", isStyled), _cx), className)
      }, children);
    }
  }]);
  return BaseHeading;
}(React.Component);
BaseHeading.defaultProps = {
  level: 3
};
BaseHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  tagName: PropTypes.string,
  // override default tagName
  level: PropTypes.number,
  // 1(50), 2(41), 3(30), 4(21), 5(17)
  isStyled: PropTypes.bool,
  // automatically adds margin when component is not first/last and center alignment for h1
  isAdaptive: PropTypes.bool,
  // should shrink on adaptivity
  className: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
} : {};

/**
 * Default export kept for backward compatibility,
 * has automatic indents
 */
var Heading = /*#__PURE__*/function (_BaseHeading) {
  _inherits(Heading, _BaseHeading);
  var _super2 = _createSuper(Heading);
  function Heading() {
    _classCallCheck(this, Heading);
    return _super2.apply(this, arguments);
  }
  return _createClass(Heading);
}(BaseHeading);
export { Heading as default };
Heading.defaultProps = {
  level: 3,
  isStyled: true,
  isAdaptive: true
};